import cn from "classnames";
import Tooltip from "rc-tooltip";
import React, { useState } from "react";
import { ProgressBar } from ".";

const colors = ["bg-primary", "bg-success", "bg-danger", "bg-warning", "bg-info"];

export default (props) => {
    return (
        <div className="card mb-3">
            <div className="card-header">
                Количество запросов: <b>{props.requestsCount.totalRequests}</b>
            </div>
            <div className="card-body">
                {props.requestsCount.topUsers.map((userData) => (
                    <UserRequestsData
                        key={userData.user}
                        {...userData}
                        overallRequestsCount={props.requestsCount.totalRequests}
                    />
                ))}
            </div>
        </div>
    );
};

const MultipleProgressBar = (props) => {
    return (
        <div className="progress progress-small w-100">
            {props.countData.map((item, i) => {
                const percentAll = Math.round((100 * item.totalRequests) / props.maxCount);
                const percentUser = Math.round((100 * item.totalRequests) / props.maxUserCount);

                return (
                    <Tooltip
                        key={item.path}
                        placement="top"
                        overlay={
                            <>
                                <b>
                                    {item.totalRequests} - {percentUser}% - {percentAll}%
                                </b>
                                <br />
                                {item.path}
                            </>
                        }
                    >
                        <div
                            className={`progress-bar ${colors[i % colors.length]} ${i % 2 === 0 ? "progress-bar-striped" : ""}`}
                            role="progressbar"
                            style={{ width: `${percentAll}%` }}
                        />
                    </Tooltip>
                );
            })}
        </div>
    );
};

const UserRequestsData = (props) => {
    const [opened, setOpened] = useState(false);
    return (
        <div key={props.user} className="mb-2">
            <div className="row">
                <div className="col-sm-3 ellipsis">
                    <div
                        className={cn("d-inline-block collapse-btn", {
                            "collapse-btn--down": !opened,
                            "collapse-btn--up": opened,
                        })}
                        onClick={() => setOpened(!opened)}
                    />
                    <span title={props.user}>{props.user}</span>
                </div>
                <div className="col-sm-9 d-flex align-items-center">
                    <ProgressBar maxCount={props.overallRequestsCount} count={props.totalRequests} />
                </div>
            </div>
            {opened && (
                <>
                    <div className="row mb-2">
                        <div className="offset-sm-3 col-sm-9 d-flex align-items-center">
                            <MultipleProgressBar
                                maxCount={props.overallRequestsCount}
                                maxUserCount={props.totalRequests}
                                countData={props.topRequests}
                            />
                        </div>
                    </div>
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <td className="text-muted small">Запрос</td>
                                <td className="text-muted small">Количество</td>
                                <td className="text-muted small">Процент от запросов пользователя</td>
                                <td className="text-muted small">Процент от всех запросов</td>
                            </tr>
                        </thead>
                        <tbody>
                            {props.topRequests.map((item) => (
                                <tr key={item.path}>
                                    <td>{item.path}</td>
                                    <td>{item.totalRequests}</td>
                                    <td>{Math.round((100 * item.totalRequests) / props.totalRequests)}%</td>
                                    <td>{Math.round((100 * item.totalRequests) / props.overallRequestsCount)}%</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </div>
    );
};
